import {
  faCartCircleCheck,
  faCircleUser,
  faCloudArrowUp,
  faListCheck,
  faUserPen,
  faUsers,
} from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Feature } from 'src/Feature';
import MyAccountPageOption from '../MyAccountPageOption';
import {
  MobileMyAccountContainer,
  MobileMyAccountHeader,
  MobileMyAccountOptionCardsContainer,
  MobileMyAccountTitle,
  MyAccountTitleContainer,
} from '../styles';
import { MyAccountPageProps } from '../types';

export function MobileMyAccountPage({
  hasPermissionsToOperateOnAllOfTenantsOrders,
  canListUsers,
  canAddProducts,
}: MyAccountPageProps) {
  const { t } = useTranslation('myAccount');

  return (
    <MobileMyAccountContainer>
      <MobileMyAccountHeader>
        <MyAccountTitleContainer>
          <FontAwesomeIcon icon={faCircleUser} size="lg" />
          <MobileMyAccountTitle>{t('myAccount.title')}</MobileMyAccountTitle>
        </MyAccountTitleContainer>
      </MobileMyAccountHeader>
      <MobileMyAccountOptionCardsContainer>
        <MyAccountPageOption
          title={t('myAccount.accountDetails.title')}
          icon={faUserPen}
          subtitle={<>{t('myAccount.accountDetails.description')}</>}
          buttonText={t('myAccount.accountDetails.cta')}
          to="account-details"
        />
        <Feature flag="shopping-cart">
          {hasPermissionsToOperateOnAllOfTenantsOrders ? (
            <MyAccountPageOption
              title={t('myAccount.receivedOrders.title')}
              icon={faListCheck}
              subtitle={<p>{t('myAccount.receivedOrders.description')}</p>}
              buttonText={t('myAccount.receivedOrders.cta')}
              to="received-orders"
              disabled
            />
          ) : (
            <MyAccountPageOption
              title={t('myAccount.myOrders.title')}
              icon={faCartCircleCheck}
              subtitle={<>{t('myAccount.myOrders.description')}</>}
              buttonText={t('myAccount.myOrders.cta')}
              to="my-orders"
            />
          )}
        </Feature>
        {canListUsers ? (
          <MyAccountPageOption
            title={t('myAccount.userManagement.title')}
            icon={faUsers}
            subtitle={<>{t('myAccount.userManagement.description')}</>}
            buttonText={t('myAccount.userManagement.cta')}
            to="user-management"
            disabled
          />
        ) : null}
        {canAddProducts ? (
          <MyAccountPageOption
            title={t('myAccount.uploads.title')}
            icon={faCloudArrowUp}
            subtitle={<>{t('myAccount.uploads.description')}</>}
            buttonText={t('myAccount.uploads.cta')}
            to="upload"
            disabled
          />
        ) : null}
      </MobileMyAccountOptionCardsContainer>
    </MobileMyAccountContainer>
  );
}
